export function SyncErrorIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.533 4.6a.5.5 0 000 .8l2.667 2A.5.5 0 0012 7V6a6 6 0 015.963 5.328 6 6 0 00-7.926 6.343 6.003 6.003 0 01-3.235-8.67 1 1 0 10-1.731-1.002 8.002 8.002 0 005.677 11.903 6 6 0 109.151-7.463A.996.996 0 0020 12a8 8 0 00-8-8V3a.5.5 0 00-.8-.4l-2.667 2zm10.174 9.693a1 1 0 010 1.414L17.414 17l1.293 1.293a1 1 0 01-1.414 1.414L16 18.414l-1.293 1.293a1 1 0 01-1.414-1.414L14.586 17l-1.293-1.293a1 1 0 111.414-1.414L16 15.586l1.293-1.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
